export enum ProjectSectionUnitJgStatus {
  NOT_INSPECTED = 'NOT_INSPECTED',
  INSPECTED = 'INSPECTED',
  COMPLETED = 'COMPLETED',
}

export const ProjectSectionUnitJgStatusMap = {
  [ProjectSectionUnitJgStatus.NOT_INSPECTED]: '未报检',
  [ProjectSectionUnitJgStatus.INSPECTED]: '已报检',
  [ProjectSectionUnitJgStatus.COMPLETED]: '已交工',
};

export const ProjectSectionUnitJgStatusOptions = [
  {
    label:
      ProjectSectionUnitJgStatusMap[ProjectSectionUnitJgStatus.NOT_INSPECTED],
    value: ProjectSectionUnitJgStatus.NOT_INSPECTED,
  },
  {
    label: ProjectSectionUnitJgStatusMap[ProjectSectionUnitJgStatus.INSPECTED],
    value: ProjectSectionUnitJgStatus.INSPECTED,
  },
  {
    label: ProjectSectionUnitJgStatusMap[ProjectSectionUnitJgStatus.COMPLETED],
    value: ProjectSectionUnitJgStatus.COMPLETED,
  },
];

export const ProjectSectionUnitJgStatusColorMap = {
  [ProjectSectionUnitJgStatus.NOT_INSPECTED]: 'color-grey',
  [ProjectSectionUnitJgStatus.INSPECTED]: 'color-primary',
  [ProjectSectionUnitJgStatus.COMPLETED]: 'color-success',
};
